<i18n locale="en">
{
  "titles" : {
    "add": "Add Action",
    "update": "Update Action"
  },
  "actions": {
    "update": "Update",
    "add": "Add"
  },
  "labels": {
    "custom-label": "Custom Label (optional)",
    "custom-label-placeholder": "Aa"
  },
  "options": {
    "locations": "Locations",
    "profile": "Profile",
    "loyalty": "Loyalty",
    "orders": "Orders",
    "catering-order": "Order Catering"
  }
}
</i18n>

<template>
  <OwnForm :submit-handler="onUpdate">
    <OwnDialog
      :model-value="true"
      class="add-link-dialog"
      @cancel="closeAndReset"
    >
      <template #heading>
        <OwnDialogHeading
          :title="editItem ? t('titles.update') : t('titles.add')"
          @cancel="closeAndReset"
        />
      </template>

      <OwnDialogContent scroll>
        <div class="flex-col gap-4">
          <OwnTouchRadioGroup
            v-model="selectedOption"
            :options="options"
            :columns="2"
          />
          <OwnInputContainer :label="t('labels.custom-label')">
            <OwnInput
              v-model="customLabel"
              :placeholder="t('labels.custom-label-placeholder')"
            />
          </OwnInputContainer>
        </div>
      </OwnDialogContent>

      <template #footer>
        <OwnDialogFooter>
          <OwnButton
            :text="editItem ? t('actions.update') : t('actions.add')"
            variant="primary"
            type="submit"
          >
            <template v-if="!editItem" #icon-right>
              <PhPlusCircle size="24" />
            </template>
          </OwnButton>
        </OwnDialogFooter>
      </template>
    </OwnDialog>
  </OwnForm>
</template>

<script>
import { PhPlusCircle } from '@phosphor-icons/vue'
import { useI18n } from 'vue-i18n'

import { OwnButton } from '@/ui/OwnButton'
import {
  OwnDialog,
  OwnDialogContent,
  OwnDialogFooter,
  OwnDialogHeading,
} from '@/ui/OwnDialog'
import { OwnForm } from '@/ui/OwnForm'
import { OwnInput } from '@/ui/OwnInput'
import { OwnInputContainer } from '@/ui/OwnInputContainer'
import { OwnTouchRadioGroup } from '@/ui/OwnTouchRadioGroup'

const options = ['profile', 'orders', 'catering-order']

export default {
  name: 'AddActionDialog',
  components: {
    OwnButton,
    OwnDialog,
    OwnDialogContent,
    OwnDialogFooter,
    OwnDialogHeading,
    OwnForm,
    OwnInput,
    OwnInputContainer,
    OwnTouchRadioGroup,
    PhPlusCircle,
  },
  props: {
    editItem: { type: Object, default: undefined },
  },
  emits: ['close', 'update'],
  setup() {
    const { t } = useI18n()

    return { t }
  },
  data() {
    return {
      customLabel: '',
      options: options.map((value) => ({
        label: this.t(`options.${value}`),
        value,
      })),
      selectedOption: undefined,
    }
  },
  created() {
    const { editItem } = this

    if (editItem) {
      this.selectedOption = editItem.params.action
      // Populate custom label if it differs from the default translation
      const defaultLabel = this.t(`options.${editItem.params.action}`)
      if (editItem.params.label && editItem.params.label !== defaultLabel) {
        this.customLabel = editItem.params.label
      }
    } else {
      this.selectedOption = options[0]
    }
  },
  methods: {
    closeAndReset() {
      this.$emit('close')
    },
    onUpdate() {
      const { selectedOption, customLabel } = this

      this.$emit('update', {
        params: {
          action: selectedOption,
          label: customLabel || this.t(`options.${selectedOption}`),
        },
        type: 'action',
      })

      this.closeAndReset()
    },
  },
}
</script>
